<template>
  <div v-if="importation">
    <div class="title mb-2 text-uppercase">
      {{ $t("transaction_detail_importation_data.title") }}
    </div>
    <div>
      {{ $t('transaction_detail_importation_data.title') }}
      {{ importation.title }}
    </div>

    <div>
      {{ $t('transaction_detail_importation_data.firstname') }}
      {{ importation.firstname }}
    </div>

    <div>
      {{ $t('transaction_detail_importation_data.address') }}
      {{ importation.address }}
    </div>

    <div>
      {{ $t('transaction_detail_importation_data.postal_code') }}
      {{ importation.postal_code }}
    </div>

    <div>
      {{ $t('transaction_detail_importation_data.mobile') }}
      {{ importation.mobile }}
    </div>

    <div>
      {{ $t('transaction_detail_importation_data.identification_number') }}
      {{ importation.identification_number }}
    </div>

    <div>
      {{ $t('transaction_detail_importation_data.town') }}
      {{ importation.town }}
    </div>

    <div>
      {{ $t('transaction_detail_importation_data.phone') }}
      {{ importation.phone }}
    </div>

    <div>
      {{ $t('transaction_detail_importation_data.email') }}
      {{ importation.email }}
    </div>
  </div>
</template>


<script>
export default {
  name: "transaction-detail-importation-data",
  props: {
    importation: {
      type: Object,
      default: undefined,
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        transaction_detail_importation_data: {
          title: "Importation data",
          firstname: "Complete name:",
          address: "Address:",
          postal_code: "Postal code:",
          mobile: "Mobile:",
          identification_number: "Identification number:",
          town: "Town:",
          phone: "Phone:",
          email: "email:",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.title {
  font-weight: bold;
}
</style>
